import React from 'react'
import PropTypes from 'prop-types'
import { HStack, Text } from '@chakra-ui/react'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function Warning({ warningText, img, variant = 'warning' }) {
  return (
    <HStack spacing="22px" w="100%">
      {!img ? (
        <FontAwesomeIcon size="3x" icon={faTriangleExclamation} />
      ) : (
        <img src={img} />
      )}
      <Text variant={variant} w="100%">
        {warningText}
      </Text>
    </HStack>
  )
}

Warning.propTypes = {
  warningText: PropTypes.string,
  img: PropTypes.any,
  variant: PropTypes.string,
}
